import { render, staticRenderFns } from "./ModalSms.vue?vue&type=template&id=04dfbb63&scoped=true"
import script from "./ModalSms.vue?vue&type=script&lang=js"
export * from "./ModalSms.vue?vue&type=script&lang=js"
import style0 from "./ModalSms.vue?vue&type=style&index=0&id=04dfbb63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfbb63",
  null
  
)

export default component.exports